import { createContext } from 'react';
import { LocalJsonStorage } from 'utils/storage';
import { SortByTypes, SortByTypesOptions } from './sorting';

export const CateringContext = createContext({});
export const AddressContext = createContext({});
export const ConfigContext = createContext({});
export const CartContext = createContext({});
export const SnackBarContext = createContext({});
export const OverlayContext = createContext({});
export const StripeContext = createContext({});
export const AuthContext = createContext({});
AuthContext.STORAGE_KEY = 'auth';
AuthContext.getUser = () => LocalJsonStorage.get(AuthContext.STORAGE_KEY);
export const ListContext = createContext({
  sortBy: SortByTypesOptions[SortByTypes.NEAR_ME],
});
export const AlertContext = createContext({});
export const LayoutContext = createContext({});
export const AppContext = createContext({});
